import * as getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  // tasting: {
  //   byId: {},
  //   allIds: []
  // },
  section: {
    byId: {},
    allIds: []
  },
  question: {
    byId: {},
    allIds: []
  },
  transition: {
    byId: {},
    allIds: []
  },
  userResponses: {
    byId: {}
  },
  tastings: [],
  firebaseId: null
}

export default {
  state,
  getters,
  actions,
  mutations
}
